import { ERROR, ERRORS, LOADING } from './types'

export const apiErrorAction = props => ({
  type: ERROR,
  payload: props
})

export const setLoadingAction = ({ type, payload }) => ({
  type: type + '/' + LOADING,
  payload
})
export const setErrorAction = ({ type, payload }) => ({
  type: type + '/' + ERRORS,
  payload
})
